import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e9111fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "epoch-progress" }
const _hoisted_2 = { class: "epoch-progress__text" }

import { computed, ref } from "vue";
import { AppState } from "@/types/AppState";


export default /*#__PURE__*/_defineComponent({
  __name: 'EpochProgress',
  props: {
    state: {}
  },
  setup(__props: any) {

const props = __props;
const items = [AppState.CHOOSE_EPOCH, AppState.PHOTO, AppState.RESULT];

const title = computed(() => {
  switch (props.state) {
    case AppState.CHOOSE_EPOCH:
      return "Выбор эпохи";
    case AppState.PHOTO:
      return "Загрузка фото";
    case AppState.RESULT:
      return "Результат";
    default:
      return "";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(title.value), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["epoch-progress__container", _ctx.state.toLowerCase()])
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
        return _createElementVNode("div", {
          key: item,
          class: _normalizeClass(["epoch-progress__dot", { 'epoch-progress__dot--active': item === _ctx.state }])
        }, null, 2)
      }), 64))
    ], 2)
  ]))
}
}

})